import { useContext } from 'react';
import { AditionContext } from '../../../components/Advertising/Adition/AditionContext.js';
export const useAdition = () => {
  const aditionContext = useContext(AditionContext);
  if (aditionContext == null) {
    throw new Error('useAdition() must be used within a <AditionProvider>');
  }
  return aditionContext;
};